import { Command } from '../../_base/actionBus/Command';

export class RefreshSession extends Command {}
